//
//
//
//
//
//
//

export default {
    name: 'my-nav',
    props: ['title', 'page', 'showBack'],
    data () {
        return {
            pageTitle: '',
            pageName: '',
            isShowBack: true
        }
    },
    methods: {
        goBack () {
            if (this.pageName !== undefined) {
                this.$router.push({
                    path: '/' + this.pageName
                })
            } else {
                this.$router.go(-1)
            }
        }
    },
    created () {
        this.pageTitle = this.title
        this.pageName = this.page
        if (this.showBack !== undefined) {
            this.isShowBack = this.showBack
        }
    }
}
